
import OrderComp from "applications/desktop/package-compare-app/components/order/order";
export default class Order extends OrderComp {}
